import api from 'api'

export const createDevolutive = async (projectId, payload) => {
  const { data } = await api.post(`/project/${projectId}/devolutive`, payload)

  return data
}
